<template>
  <div class="container-fluid py-4">
    <!-- Header moderne -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-hospital fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Nouvelle Hospitalisation</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'liste_hospitalisation' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">
      <div class="row g-4">
        <!-- Patient -->
        <div class="col-md-6">
          <label for="patient" class="form-label fw-semibold">Patient</label>
          <select id="patient" v-model="hospitalisation.patientId" class="form-select form-select-clinique" :class="{ 'is-invalid': error.patientId }">
            <option value="" disabled>-- Sélectionnez un patient --</option>
            <option v-for="p in patients" :key="p.id" :value="p.id">{{ p.nom }} {{ p.prenom }}</option>
          </select>
          <div class="invalid-feedback">{{ error.patientId }}</div>
        </div>

        <!-- Chambre -->
        <div class="col-md-6">
          <label for="chambre" class="form-label fw-semibold">Chambre</label>
          <select id="chambre" v-model="hospitalisation.chambreId" class="form-select form-select-clinique">
            <option value="" disabled>-- Sélectionnez une chambre --</option>
            <option v-for="c in chambres" :key="c.id" :value="c.id">{{ c.nom }}</option>
          </select>
        </div>

        <!-- Lit -->
        <div class="col-md-6">
          <label for="lit" class="form-label fw-semibold">Lit</label>
          <select id="lit" v-model="hospitalisation.litId" class="form-select form-select-clinique">
            <option value="" disabled>-- Sélectionnez un lit --</option>
            <option v-for="l in lits" :key="l.id" :value="l.id">{{ l.nom }}</option>
          </select>
        </div>

        <!-- Date entrée -->
        <div class="col-md-6">
          <label for="dateEntree" class="form-label fw-semibold">Date d'entrée</label>
          <input type="datetime-local" id="dateEntree" v-model="hospitalisation.dateEntree" class="form-control form-control-clinique" :class="{ 'is-invalid': error.dateEntree }">
          <div class="invalid-feedback">{{ error.dateEntree }}</div>
        </div>

        <!-- Montant facture -->
        <div class="col-md-6">
          <label for="montantFacture" class="form-label fw-semibold">Montant Facture</label>
          <input type="number" id="montantFacture" v-model="hospitalisation.montantFacture" class="form-control form-control-clinique" placeholder="Ex: 50000">
        </div>

        <!-- Statut
        <div class="col-md-6">
          <label for="statut" class="form-label fw-semibold">Statut</label>
          <select id="statut" v-model="hospitalisation.statut" class="form-select form-select-clinique">
            <option value="" disabled>-- Sélectionnez --</option>
            <option value="En cours">En cours</option>
            <option value="Terminé">Terminé</option>
            <option value="Annulé">Annulé</option>
          </select>
        </div> -->
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isLoading" @click="saveHospitalisation">
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: false,
      hospitalisation: {
        patientId: '',
        chambreId: '',
        litId: '',
        dateEntree: '',
        montantFacture: '',
        statut: 'En cours',
        createdBy: null,
      },
      error: {
        patientId: '',
        dateEntree: ''
      },
      patients: [],
      chambres: [],
      lits: []
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters.user;
    }
  },
  methods: {
    validateForm() {
      this.error = {
        patientId: this.hospitalisation.patientId ? '' : 'Le patient est requis',
        dateEntree: this.hospitalisation.dateEntree ? '' : "La date d'entrée est requise",
      };
      return !Object.values(this.error).some(err => err !== '');
    },
    async saveHospitalisation() {
      if (!this.validateForm() || this.isLoading) return;
      try {
        const payload = { ...this.hospitalisation, createdBy: this.currentUser.id };
        this.isLoading = true;
        console.log(payload);
        //await api.createItem('hospitalisations', payload);
        //alert("Hospitalisation créée avec succès !");
        //this.$router.push({ name: 'hospitalisations' });
      } catch (error) {
        console.error("Erreur lors de la création de l'hospitalisation", error);
        alert("Une erreur s'est produite lors de l'enregistrement.");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$router.push({ name: 'hospitalisations' });
    },
    async loadData() {
      try {
        const [p, c, l] = await Promise.all([
          api.getItems('patients'),
          api.getItems('chambres'),
          api.getItems('lits'),
        ]);
        this.patients = p.data.data || [];
        this.chambres = c.data.data || [];
        this.lits = l.data.data || [];
      } catch (err) {
        console.error("Erreur lors du chargement des listes :", err);
      }
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style scoped>
/* --- Header clinique --- */
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

/* --- Card formulaire --- */
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

/* --- Champs --- */
.form-control-clinique,
.form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus,
.form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

/* --- Boutons --- */
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>
